// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-search .ant-input {
  background-color: #1F1717; /* Background color of the input field */
  border: 2px solid #4E3636; /* Border color */
  color: #fff; /* Text color inside the input */
}

.custom-search .ant-input::placeholder {
  color: #aaa; /* Placeholder text color */
  opacity: 1; /* Ensure the placeholder color is fully visible */
}

.custom-search .ant-input:hover {
  border-color: #f05454; /*Border color on hover*/
}

/* .custom-search .ant-input-focused { */
  /* border-color: #f05454; Border color when input is focused */
/* } */

.ant-modal-confirm {
 
  .ant-btn-primary {
    background-color: #ff4d4f; /* Red background for primary button */
    border-color: #ff4d4f; /* Red border color for primary button */
  }

  .ant-btn-primary:hover {
    background-color: #151515; /* Lighter red on hover */
    border-color: #151515; /* Lighter red border on hover */
  }

  .ant-btn {
    color: #151515; /* Red text color for buttons */
  }

   .ant-btn:hover {
    color: #151515; /* Red text color for buttons */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,yBAAyB,EAAE,iBAAiB;EAC5C,WAAW,EAAE,gCAAgC;AAC/C;;AAEA;EACE,WAAW,EAAE,2BAA2B;EACxC,UAAU,EAAE,kDAAkD;AAChE;;AAEA;EACE,qBAAqB,EAAE,wBAAwB;AACjD;;AAEA,wCAAwC;EACtC,8DAA8D;AAChE,MAAM;;AAEN;;EAEE;IACE,yBAAyB,EAAE,sCAAsC;IACjE,qBAAqB,EAAE,wCAAwC;EACjE;;EAEA;IACE,yBAAyB,EAAE,yBAAyB;IACpD,qBAAqB,EAAE,gCAAgC;EACzD;;EAEA;IACE,cAAc,EAAE,+BAA+B;EACjD;;GAEC;IACC,cAAc,EAAE,+BAA+B;EACjD;AACF","sourcesContent":[".custom-search .ant-input {\n  background-color: #1F1717; /* Background color of the input field */\n  border: 2px solid #4E3636; /* Border color */\n  color: #fff; /* Text color inside the input */\n}\n\n.custom-search .ant-input::placeholder {\n  color: #aaa; /* Placeholder text color */\n  opacity: 1; /* Ensure the placeholder color is fully visible */\n}\n\n.custom-search .ant-input:hover {\n  border-color: #f05454; /*Border color on hover*/\n}\n\n/* .custom-search .ant-input-focused { */\n  /* border-color: #f05454; Border color when input is focused */\n/* } */\n\n.ant-modal-confirm {\n \n  .ant-btn-primary {\n    background-color: #ff4d4f; /* Red background for primary button */\n    border-color: #ff4d4f; /* Red border color for primary button */\n  }\n\n  .ant-btn-primary:hover {\n    background-color: #151515; /* Lighter red on hover */\n    border-color: #151515; /* Lighter red border on hover */\n  }\n\n  .ant-btn {\n    color: #151515; /* Red text color for buttons */\n  }\n\n   .ant-btn:hover {\n    color: #151515; /* Red text color for buttons */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
